import { JsonObject, JsonProperty } from 'json-ts-mapper';
import { Unite } from './unite';

@JsonObject
export class Conditionnement {
  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  code: string;

  @JsonProperty(String)
  libelle: string;

  @JsonProperty(String)
  commentaire: string;

  @JsonProperty(String)
  codeUniteBase: string;

  @JsonProperty(Number)
  facteurUniteBase: number;
}
